module.exports = "<span *ngIf=\"policyText\" [innerText]=\"policyText\" data-slnm-ihg=\"depositPolicySID\"></span>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/deposit-policy/deposit-policy.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/deposit-policy/deposit-policy.component.html
// module chunks = 0